(() => {
  function init(root){
    if (!root || root.dataset.rpntInitialized === 'true') return;
    root.dataset.rpntInitialized = 'true';

    const q = (sel) => root.querySelector(sel);
    const glitch = q('[data-glitch]');
    if (glitch) setInterval(() => {
      if (Math.random() > .45) {
        glitch.classList.remove('hit');
        void glitch.offsetWidth;
        glitch.classList.add('hit');
      }
    }, 7600);

    const tc = q('[data-timecode]');
    let sec = 12;
    if (tc) setInterval(() => {
      sec = (sec + 1) % 60;
      tc.textContent = '23:49:' + String(sec).padStart(2, '0');
    }, 1000);

    const discoveryModal = q('[data-discovery-modal]');
    const openDiscovery = q('[data-open-discovery]');
    const closeDiscovery = q('[data-close-discovery]');
    const discoveryVideo = discoveryModal?.querySelector('video');
    const openDiscoveryModal = () => {
      if (!discoveryModal) return;
      discoveryModal.classList.add('open');
      discoveryModal.setAttribute('aria-hidden','false');
      document.body.style.overflow='hidden';
      if (discoveryVideo) discoveryVideo.play().catch(() => {});
    };
    const closeDiscoveryModal = () => {
      if (!discoveryModal) return;
      discoveryModal.classList.remove('open');
      discoveryModal.setAttribute('aria-hidden','true');
      document.body.style.overflow='';
      if (discoveryVideo) discoveryVideo.pause();
    };
    openDiscovery?.addEventListener('click', openDiscoveryModal);
    closeDiscovery?.addEventListener('click', closeDiscoveryModal);
    discoveryModal?.addEventListener('click', e => { if (e.target === discoveryModal) closeDiscoveryModal(); });

    // subtle trace event: acquire a random source -> route it to the leak node
    const traceRadar = q('[data-trace-radar]');
    const traceLock = traceRadar?.querySelector('.trace-lock');
    const routeLine = traceRadar?.querySelector('.restricted-route-line');
    const leakPacket = traceRadar?.querySelector('.leak-packet');
    const leakNode = traceRadar?.querySelector('.trace-node-clean.leak');
    let traceEventTimer = null;
    let traceEventCleanupTimer = null;
    let lastTraceTarget = -1;
    const traceTargets = [{x:31,y:25},{x:28,y:72},{x:65,y:72}];
    function pickTraceTarget(){
      let index;
      do { index=Math.floor(Math.random()*traceTargets.length); }
      while(traceTargets.length>1 && index===lastTraceTarget);
      lastTraceTarget=index;
      return traceTargets[index];
    }
    function positionTraceEvent(){
      if(!traceRadar || !traceLock || !routeLine || !leakPacket || !leakNode) return false;
      const target=pickTraceTarget();
      const radarRect=traceRadar.getBoundingClientRect();
      const sx=radarRect.width*(target.x/100), sy=radarRect.height*(target.y/100);
      const leakDot=leakNode.querySelector('.trace-dot-clean');
      const dotRect=(leakDot || leakNode).getBoundingClientRect();
      const ex=(dotRect.left+dotRect.width/2)-radarRect.left, ey=(dotRect.top+dotRect.height/2)-radarRect.top;
      const dx=ex-sx, dy=ey-sy, distance=Math.hypot(dx,dy), angle=Math.atan2(dy,dx)*180/Math.PI;
      traceLock.style.left=`${sx}px`; traceLock.style.top=`${sy}px`;
      routeLine.style.left=`${sx}px`; routeLine.style.top=`${sy}px`; routeLine.style.width=`${distance}px`;
      routeLine.style.setProperty('--route-transform',`rotate(${angle}deg)`);
      leakPacket.style.left=`${sx}px`; leakPacket.style.top=`${sy}px`;
      leakPacket.style.setProperty('--packet-x',`${dx}px`); leakPacket.style.setProperty('--packet-y',`${dy}px`);
      return true;
    }
    function scheduleNextTraceEvent(){
      clearTimeout(traceEventTimer);
      traceEventTimer=setTimeout(runTraceEvent,3000+Math.random()*6000);
    }
    function runTraceEvent(){
      if(!traceRadar || !positionTraceEvent()) return scheduleNextTraceEvent();
      clearTimeout(traceEventCleanupTimer);
      traceRadar.classList.remove('trace-event'); void traceRadar.offsetWidth; traceRadar.classList.add('trace-event');
      traceEventCleanupTimer=setTimeout(()=>traceRadar.classList.remove('trace-event'),3650);
      scheduleNextTraceEvent();
    }
    scheduleNextTraceEvent();

    // Files terminal only animates while visible
    const filesSection=q('#repentless-files');
    const filesTerminalPanel=q('[data-files-terminal-panel]');
    const filesTerminalAuthText=q('[data-files-terminal-auth-text]');
    let filesVisible=false, filesReplayTimer=null, filesAuthStartTimer=null, filesAuthTypeTimer=null;
    function clearFilesTimers(){ clearTimeout(filesReplayTimer); clearTimeout(filesAuthStartTimer); clearInterval(filesAuthTypeTimer); }
    function playFilesTerminal(){
      if(!filesVisible || !filesTerminalPanel) return;
      clearFilesTimers();
      filesTerminalPanel.classList.remove('active');
      if(filesTerminalAuthText) filesTerminalAuthText.textContent='';
      void filesTerminalPanel.offsetWidth; filesTerminalPanel.classList.add('active');
      if(filesTerminalAuthText){
        const message='ACCESS DENIED // VALID CREDENTIALS NOT FOUND'; let i=0;
        filesAuthStartTimer=setTimeout(()=>{
          filesAuthTypeTimer=setInterval(()=>{
            filesTerminalAuthText.textContent=message.slice(0,++i);
            if(i>=message.length) clearInterval(filesAuthTypeTimer);
          },28);
        },950);
      }
      filesReplayTimer=setTimeout(playFilesTerminal,12500+Math.random()*2500);
    }
    if(filesSection && filesTerminalPanel && 'IntersectionObserver' in window){
      const observer=new IntersectionObserver(entries=>{
        entries.forEach(entry=>{
          const visible=entry.isIntersecting && entry.intersectionRatio>=.22;
          if(visible && !filesVisible){ filesVisible=true; setTimeout(()=>{if(filesVisible) playFilesTerminal();},250); }
          if(!visible && filesVisible){ filesVisible=false; clearFilesTimers(); filesTerminalPanel.classList.remove('active'); if(filesTerminalAuthText) filesTerminalAuthText.textContent=''; }
        });
      },{threshold:[0,.22,.5]});
      observer.observe(filesSection);
    }

    // Restricted archive terminal. This is an intentional client-side campaign gate, not security for sensitive data.
    const terminalModal=q('[data-terminal-modal]');
    const terminalTrace=q('[data-archive-trace]');
    const terminalClose=q('[data-terminal-close]');
    const terminalOutput=q('[data-terminal-output]');
    const terminalAuth=q('[data-terminal-auth]');
    const terminalKeyForm=q('[data-terminal-key-form]');
    const terminalKeyInput=q('[data-terminal-key-input]');
    const terminalSequence=[
      {t:'> INITIALISING SECURE SESSION...',c:'command',d:90},
      {t:'> RESOLVING NODE /RPT/DAY_0/ARCHIVE',c:'command',d:390},
      {t:'> HANDSHAKE ACCEPTED',c:'ok',d:720},
      {t:'> MOUNTING RECOVERED DIRECTORY...',c:'command',d:1050},
      {t:'> 03 FILES DETECTED // ADDITIONAL RECORDS HIDDEN',c:'dim',d:1450},
      {t:'> REQUESTING ARCHIVE ACCESS...',c:'command',d:1830},
      {t:'ACCESS DENIED // CLEARANCE REQUIRED',c:'warn',d:2320},
      {t:'> VALID ACCESS KEY NOT FOUND',c:'dim',d:2680}
    ];
    let terminalTimers=[];
    function resetTerminal(){
      terminalTimers.forEach(clearTimeout); terminalTimers=[];
      if(terminalOutput) terminalOutput.innerHTML='';
      terminalAuth?.classList.remove('active');
      if(terminalKeyInput){ terminalKeyInput.value=''; terminalKeyInput.disabled=false; }
      const submitButton=terminalKeyForm?.querySelector('button[type="submit"]');
      if(submitButton) submitButton.disabled=false;
    }
    function runTerminal(){
      resetTerminal();
      terminalSequence.forEach(({t,c,d})=>terminalTimers.push(setTimeout(()=>{
        const line=document.createElement('div'); line.className='term-line '+c; line.textContent=t; terminalOutput?.appendChild(line);
      },d)));
      terminalTimers.push(setTimeout(()=>terminalAuth?.classList.add('active'),3050));
    }
    function openTerminal(){ terminalModal?.classList.add('open'); terminalModal?.setAttribute('aria-hidden','false'); document.body.style.overflow='hidden'; runTerminal(); }
    function closeTerminal(){ terminalModal?.classList.remove('open'); terminalModal?.setAttribute('aria-hidden','true'); document.body.style.overflow=''; resetTerminal(); }
    terminalTrace?.addEventListener('click',openTerminal);
    terminalClose?.addEventListener('click',closeTerminal);
    terminalModal?.addEventListener('click',e=>{if(e.target===terminalModal) closeTerminal();});
    terminalKeyForm?.addEventListener('submit',e=>{
      e.preventDefault();
      const key=terminalKeyInput?.value.trim();
      if(!key) return;

      /*
        ACCESS NOTE //

        You found the key check.

        Cute.

        Just remember:
        you only found it because we let you.

        Have fun breaking into REPENTLESS FILES.
      */
      const ACCESS_KEY='RPT-D0-FILES';
      const normalizedKey=key.toUpperCase();

      if(normalizedKey===ACCESS_KEY){
        try { sessionStorage.setItem('rpt_day0_access','granted'); } catch (_) {}

        if(terminalKeyInput) terminalKeyInput.disabled=true;
        const submitButton=terminalKeyForm?.querySelector('button[type="submit"]');
        if(submitButton) submitButton.disabled=true;

        const accepted=document.createElement('div');
        accepted.className='term-line ok';
        accepted.textContent='> CREDENTIAL ACCEPTED';
        terminalOutput?.appendChild(accepted);

        terminalTimers.push(setTimeout(()=>{
          const granted=document.createElement('div');
          granted.className='term-line ok';
          granted.textContent='> CLEARANCE GRANTED // SESSION_01';
          terminalOutput?.appendChild(granted);
        },260));

        terminalTimers.push(setTimeout(()=>{
          const route=document.createElement('div');
          route.className='term-line command';
          route.textContent='> ESTABLISHING SECURE ROUTE...';
          terminalOutput?.appendChild(route);
        },560));

        terminalTimers.push(setTimeout(()=>{
          window.location.href='/pages/repentless-files';
        },1050));
        return;
      }

      const line=document.createElement('div');
      line.className='term-line warn';
      line.textContent='KEY NOT RECOGNISED // VERIFY CREDENTIALS';
      terminalOutput?.appendChild(line);
      terminalKeyInput.value='';
      terminalKeyInput.focus();
    });

    document.addEventListener('keydown',e=>{
      if(e.key!=='Escape') return;
      if(terminalModal?.classList.contains('open')) closeTerminal();
      else if(discoveryModal?.classList.contains('open')) closeDiscoveryModal();
    });
  }

  const initAll = () => document.querySelectorAll('[data-repentless-day0]').forEach(init);
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll); else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
